import React from 'react';

const Dashboard = React.lazy(() => import('views/dashboard/dashboard').then(m => ({ default: m.Dashboard })));
const Leads = React.lazy(() => import('views/leads'));
const Engage = React.lazy(() => import('views/engage/engage'));
const Help = React.lazy(() => import('views/dashboard/help').then(m => ({ default: m.Help })));
const Meet = React.lazy(() => import('views/meet/meet'));
const Import = React.lazy(() => import('views/leads/import/import'));
const Tasks = React.lazy(() => import('views/engage/tasks'));
const Conditions = React.lazy(() => import('views/engage/conditions'));
const TaskTemplates = React.lazy(() => import('views/engage/tasktemplates'));
const EditSequence = React.lazy(() => import('views/engage/editSequence'));
const ManageUnsubscribed = React.lazy(() => import('views/engage/manageunsubscribed'));
const EmailTemplate = React.lazy(() => import('views/engage/emailTemplate'));
const GenerateChatGPTSequence = React.lazy(() => import('views/engage/generateChatGPTSequence'));
const EmailDeliverabilityReport = React.lazy(() => import('views/engage/emailDeliverabilityReport'));
const Activities = React.lazy(() => import('views/leads/activities'));
const Inbox = React.lazy(() => import('views/inbox'));
const SequenceStats = React.lazy(() => import('views/engage/sequenceStats'));
const Verification = React.lazy(() => import('views/verification/Verification'));
const Rewards = React.lazy(() => import('views/dashboard/rewards').then(m => ({ default: m.Rewards })));

const Routes = [
  {
    path: '/',
    view: Dashboard,
    layout: 'app',
    permission: 'user',
    title: 'Dashboard',
  },
  {
    path: '/rewards',
    view: Rewards,
    layout: 'app',
    permission: 'user',
    title: 'Rewards',
  },
  {
    path: '/dashboard',
    view: Dashboard,
    layout: 'app',
    permission: 'user',
    title: 'Dashboard',
  },
  {
    path: '/verification',
    view: Verification,
    layout: 'auth',
    permission: 'user',
    title: 'Verification',
  },
  {
    path: '/inbox',
    view: Inbox,
    layout: 'app',
    permission: 'user',
  },
  {
    path: '/leads',
    view: Leads,
    layout: 'app',
    permission: 'user',
  },
  {
    path: '/contact/:contactID',
    view: Activities,
    layout: 'app',
    permission: 'user',
  },
  {
    path: '/outreach',
    view: Engage,
    layout: 'app',
    permission: 'user',
  },
  {
    path: '/outreach/:tab',
    view: Engage,
    layout: 'app',
    permission: 'user',
  },
  {
    path: '/outreach/:tab/:listID',
    view: Engage,
    layout: 'app',
    permission: 'user',
  },
  {
    path: '/outreach/templates/:id',
    view: EmailTemplate,
    layout: 'app',
    permission: 'user',
  },
  {
    path: '/manage-unsubscribed',
    view: ManageUnsubscribed,
    layout: 'app',
    permission: 'user',
    title: 'Manage Unsubscribed',
  },
  {
    path: '/task-types',
    view: Tasks,
    layout: 'app',
    permission: 'user',
    title: 'Tasks',
  },
  {
    path: '/task-types/:taskID/conditions',
    view: Conditions,
    layout: 'app',
    permission: 'user',
    title: 'Conditions',
  },
  {
    path: '/task-types/:taskID/templates',
    view: TaskTemplates,
    layout: 'app',
    permission: 'user',
    title: 'Task Templates',
  },
  {
    path: '/task-types/:taskID/templates/:templateID',
    view: TaskTemplates,
    layout: 'app',
    permission: 'user',
    title: 'Task Templates',
  },
  {
    path: '/meet',
    view: Meet,
    layout: 'app',
    permission: 'user',
    title: 'Meet',
  },
  {
    path: '/meet/:tab',
    view: Meet,
    layout: 'app',
    permission: 'user',
  },
  {
    path: '/help',
    view: Help,
    layout: 'app',
    permission: 'user',
    title: 'Get Help',
  },
  {
    path: '/import-list/:list_id',
    view: Import,
    layout: 'app',
    permission: 'user',
    title: 'Import List | SalesBlink',
  },
  {
    path: '/outreach/sequences/:sequenceID',
    view: EditSequence,
    layout: 'app',
    permission: 'user',
    title: 'Edit Sequence | SalesBlink',
  },
  {
    path: '/outreach/sequences/:id/reports',
    view: EditSequence,
    layout: 'app',
    permission: 'user',
    title: 'Sequence Report | SalesBlink',
  },
  {
    path: '/outreach/sequences/:id/stats',
    view: SequenceStats,
    layout: 'app',
    permission: 'user',
    title: 'Sequence Stats | SalesBlink',
  },
  {
    path: '/outreach/sequences/:id/generate',
    view: GenerateChatGPTSequence,
    layout: 'app',
    permission: 'user',
    title: 'Sequence Generate | SalesBlink',
  },
  {
    path: '/outreach/email-senders/:id/deliverability',
    view: EmailDeliverabilityReport,
    layout: 'app',
    permission: 'user',
    title: 'Email Deliverability | SalesBlink',
  },
];

export default Routes;
